import React from 'react';
import { Td } from '@chakra-ui/react';
import { flexRender } from '@tanstack/react-table';

/**
 * Celda de tabla admin: respeta meta.minWidth / meta.width de columnDef.
 */
export default function AdminTableCell({ cell, children, ...rest }) {
  const meta = cell.column.columnDef.meta ?? {};
  const preferNowrap = Boolean(meta.minWidth || meta.width);

  const whiteSpace =
    meta.whiteSpace ?? (preferNowrap ? 'nowrap' : undefined);

  return (
    <Td
      borderColor="transparent"
      minW={meta.minWidth}
      w={meta.width}
      maxW={meta.maxWidth}
      whiteSpace={whiteSpace}
      wordBreak={whiteSpace === 'normal' ? 'break-word' : undefined}
      overflowWrap={whiteSpace === 'normal' ? 'anywhere' : undefined}
      verticalAlign={whiteSpace === 'normal' ? 'top' : undefined}
      {...rest}
    >
      {children ?? flexRender(cell.column.columnDef.cell, cell.getContext())}
    </Td>
  );
}
